import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { umbracoApi, ParsedBlock } from '../services/umbracoApi';
import { usePageReady } from '../contexts/PageReadyContext';
import { BlockGrid } from '../components/BlockGrid/BlockGrid';
import styles from './HomePage.module.css';

export const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { setPageReady } = usePageReady();
  const [blocks, setBlocks] = useState<ParsedBlock[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Flip pageReady to false synchronously before first paint — avoids a flash
  // of the layout in its pre-fetch state (which would cause a CLS spike when
  // content arrives and shoves the footer down).
  useLayoutEffect(() => {
    setPageReady(false);
  }, [setPageReady]);

  useEffect(() => {
    const loadPage = async () => {
      try {
        const page = await umbracoApi.getFrontPage();
        const mainContent = page.properties.mainContent;
        const parsedBlocks = umbracoApi.parseBlockGridFromApi(mainContent);
        setBlocks(parsedBlocks);
      } catch (err) {
        console.error('Failed to load home page:', err);
        setError(t('home.error'));
      } finally {
        setLoading(false);
        setPageReady(true);
      }
    };

    loadPage();
  }, [t, setPageReady]);

  if (loading) {
    return <div className={styles.loading}>{t('home.loading')}</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <div className={styles.homePage}>
      <BlockGrid blocks={blocks} />
    </div>
  );
};
